import { apiRequest } from './api'

export interface PromoCode {
  id: string
  code: string
  amountMYR: number
  isActive: boolean
  createdBy: string
  createdByEmail?: string | null
  usageCount: number
  createdAt: string
  updatedAt: string
}

export interface PromoAudit {
  id: string
  action: string
  changes: Record<string, { from?: unknown; to?: unknown }>
  createdAt: string
  actorEmail?: string | null
}

export interface PromoRedemption {
  id: string
  feeAppliedMYR: number
  createdAt: string
  email: string | null
  memberId: string | null
}

export interface PromoDetail extends PromoCode {
  redemptions: PromoRedemption[]
  audits: PromoAudit[]
}

export const promosService = {
  async list(): Promise<PromoCode[]> {
    const response = await apiRequest.get<PromoCode[]>('/promos')
    return response.data
  },

  async detail(id: string): Promise<PromoDetail> {
    const response = await apiRequest.get<PromoDetail>(`/promos/${id}`)
    return response.data
  },

  /** Creates a code. When a case-insensitive near-duplicate exists the server
   *  throws with `needsConfirmation: true` — re-call with confirm to proceed. */
  async create(data: { code: string; amountMYR: number; isActive?: boolean; confirmCaseDuplicate?: boolean }): Promise<PromoCode> {
    const response = await apiRequest.post<PromoCode>('/promos', data)
    return response.data
  },

  async update(id: string, data: { amountMYR?: number; isActive?: boolean }): Promise<PromoCode> {
    const response = await apiRequest.put<PromoCode>(`/promos/${id}`, data)
    return response.data
  },
}
